/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `OCEAN_FREIGHT_COST` - Ocean Freight Cost
* `LOCAL_ORIGIN_COST` - Local Origin Cost
* `LOCAL_DESTINATION_COST` - Local Destination Cost
* `ORIGIN_TERMINAL_HANDLING_CHARGE` - Origin Terminal Handling Charge
* `DESTINATION_TERMINAL_HANDLING_CHARGE` - Destination Terminal Handling Charge
* `ORIGIN_INTERMODAL_COST` - Origin Intermodal Cost
* `DESTINATION_INTERMODAL_COST` - Destination Intermodal Cost
* `ORIGIN_DOC_FEE` - Origin Documentation Fee
 */
export type MissingCostsEnum = typeof MissingCostsEnum[keyof typeof MissingCostsEnum];


export const MissingCostsEnum = {
  OCEAN_FREIGHT_COST: 'OCEAN_FREIGHT_COST',
  LOCAL_ORIGIN_COST: 'LOCAL_ORIGIN_COST',
  LOCAL_DESTINATION_COST: 'LOCAL_DESTINATION_COST',
  ORIGIN_TERMINAL_HANDLING_CHARGE: 'ORIGIN_TERMINAL_HANDLING_CHARGE',
  DESTINATION_TERMINAL_HANDLING_CHARGE: 'DESTINATION_TERMINAL_HANDLING_CHARGE',
  ORIGIN_INTERMODAL_COST: 'ORIGIN_INTERMODAL_COST',
  DESTINATION_INTERMODAL_COST: 'DESTINATION_INTERMODAL_COST',
  ORIGIN_DOC_FEE: 'ORIGIN_DOC_FEE',
} as const;
